'use es6';

import { HISTORY_METHOD_CALLED } from 'DesignData/actions/ActionTypes';

const createAction = method => location => ({
  type: HISTORY_METHOD_CALLED,
  payload: {
    method,
    args: [location]
  }
});

export const push = createAction('push');
export const replace = createAction('replace');